import React, { Component } from 'react'
import './Stores.css'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as masterSettingsAction from '../../actions/masterSettings'
import t from '../Language/language'

import SystemStatus from './SystemStatus'
import * as languageSettings from '../Language/languageSettings'
import { confirmAlert } from 'react-confirm-alert'

const _ = require('underscore')

class MasterSettings extends Component {
  constructor (props) {
    super(props)
    this.state = {
      currentLanguage: languageSettings.getCurrentLanguage(),
      selectAll: false,
      confirmMessage: 'Are you sure you would like to send settings to the selected system(s)?',
      settings: [],
      destinations: [],
      selectAllSettings: false,
      selectAllDestination: false,
      errors: []
    }
  }
  componentWillMount () {
    const params = new URLSearchParams(this.props.history.location.search)
    const duid = params.get('duid') ? params.get('duid') : null
    this.props.getMasterSettings(duid)
  }
  render () {
    const destinationsAll = this.state.selectAllSettings
    const settingsAll = this.state.selectAllSettings
    if (this.props.masterSettings) {
      return (
        <section>
          <section className={'settingsErrors ' + (this.state.errors.length > 0 ? '' : 'hidden')}>
            <div>The following errors occured during your request: </div>
            <ul>
              {this.renderErrors()}
            </ul>
          </section>
          <section className='masterSettings'>
            <section>
              <SystemStatus data={this.props.masterSettings.storeViewDetails} />
              <div className='settingsSection'>
                <h3 className='clear versions'>Settings</h3>
                <div className='alignItems selectAllHeader'>
                  <input type='checkbox' name='settings' id='settings' onClick={this.selectAllSettigs.bind(this, settingsAll)} />
                  <label htmlFor='settings' className='clear'>Select All</label>
                </div>
                <div id='availSettingsBox' className='form_cbox' name=''>
                  <div>
                    {this.renderSettings()}
                  </div>
                </div>
              </div>
            </section>
            <section className='destinationSectionRight'>
              <div className='destinationSection'>
                <div className='settingsSection destinationdeviceSection'>
                  <h3 className='clear versions'>Destination</h3>
                  <div className='alignItems selectAllHeader'>
                    <input type='checkbox' name='destinations' id='destinations' onClick={this.selectAllDestinations.bind(this, destinationsAll)} />
                    <label htmlFor='destinations' className='clear'>Select All</label>
                  </div>
                  <div id='availSettingsBox' className='form_cbox' name=''>
                    <div>
                      { this.renderDestinations() }
                    </div>
                  </div>
                </div>
              </div>
              <div id='settings-content'>
                <input id='settings-btn' type='submit' value='Apply' onClick={this.confirm.bind(this)} />
            &nbsp;|&nbsp;<a className='cancel_btn' href={'../settings/stores/viewDetail?duid=' + this.props.masterSettings.storeViewDetails.systemStatus[0].Device_UID}>Cancel</a>
              </div>
            </section>
          </section>
        </section>
      )
    } else {
      return ''
    }
  }
  renderErrors () {
    let errors = this.state.errors
    let settingsErrors = errors.map(function (error, index) {
      return (
        <li> { error }</li>
      )
    })
    return settingsErrors
  }
  onCheckSettings (id, e) {
    const Options = this.props.masterSettings.settingsList
    Options.map(function (Option, index) {
      if (Option.id === id) {
        Option.checked = !Option.checked
      }
    })
    this.setState({ settings: Options })
  }
  onCheckDestinations (id, e) {
    const Options = this.props.masterSettings.destinationList
    Options.map(function (Option, index) {
      if (Option.DestinationId === id) {
        Option.checked = !Option.checked
      }
    })
    this.setState({ destinations: Options })
  }

  renderSettings () {
    let self = this
    if (this.props.masterSettings.settingsList) {
      const Options = this.props.masterSettings.settingsList
      let roleOptions = Options.map(function (Option, index) {
        return (
          <div className='alignItems'>
            <input type='checkbox' checked={Option.checked} item={Options} name='Settings_List' value={Option.id} id={Option.id} onClick={self.onCheckSettings.bind(self, Option.id)} />
            <label htmlFor={Option.id} className='clear'>{Option.label}</label>
          </div>
        )
      })
      return roleOptions
    }
  }

  renderDestinations () {
    let self = this
    if (this.props.masterSettings) {
      let Options = this.props.masterSettings.destinationList
      let destinations = Options.map(function (Option, index) {
        return (
          <div className='alignItems'>
            <input type='checkbox' checked={Option.checked} name='Settings_List' value={Option.DestinationId} id={Option.DestinationId} onClick={self.onCheckDestinations.bind(self, Option.DestinationId)} />
            <label htmlFor={Option.DestinationId} className='clear'>{Option.label}</label>
          </div>
        )
      })
      return destinations
    }
  }

  selectAllSettigs (state, e) {
    let Options = this.props.masterSettings.settingsList
    let settingsState = this.state.selectAll
    Options.map(function (Option, index) {
      Option.checked = !settingsState
    })
    this.state.selectAll = !this.state.selectAll
    this.setState(this.state)
    this.setState({ settings: Options })
  }

  confirm () {
    let self = this
    confirmAlert({
      title: t[this.state.currentLanguage]['ConfirmationRequired'],
      message: this.state.confirmMessage,
      buttons: [
        {
          label: 'Apply Now',
          onClick: () => {
            self.submit()
          }
        },
        {
          label: 'Cancel',
          onClick: () => { }
        }
      ]
    })
  }
  selectAllDestinations (state, e) {
    let Options = this.props.masterSettings.destinationList
    let destinationState = this.state.selectAllDestination
    Options.map(function (Option, index) {
      Option.checked = !destinationState
    })
    this.state.selectAllDestination = !this.state.selectAllDestination
    this.setState(this.state)
    this.setState({ destinations: Options })
  }

  submit () {
    this.setState({ errors: [] })
    let settings = _.where(this.state.settings, { checked: true })
    let destinations = _.where(this.state.destinations, { checked: true })
    let params = {
      'duid': this.props.masterSettings.storeViewDetails.systemStatus[0].Device_UID,
      'settingsList': _.pluck(settings, 'id').toString(),
      'destList': _.pluck(destinations, 'DestinationId').toString()
    }
    let self = this
    let errors = []
    if (params.destList.length === 0) {
      errors.push('No destination devices selected.')
    }
    if (params.settingsList.length === 0) {
      errors.push('No settings selected.')
    }
    if (errors.length === 0) {
      this.props.saveMasterSettings(params, function (data) {
        if (data.status) {
          self.props.history.push('/message', 'settingsSent')
        } else {
          let errors = []
          errors.push(data.data)
          self.setState({ errors })
        }
      })
    } else {
      this.setState({ errors })
    }
  }
}

function mapStateToProps (state) {
  return {
    viewDetails: state.viewDetails,
    masterSettings: state.masterSettings.masterSettings
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getMasterSettings: masterSettingsAction.getMasterSettings,
      saveMasterSettings: masterSettingsAction.saveMasterSettings
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(MasterSettings)



// WEBPACK FOOTER //
// ./src/components/Stores/MasterSettings.js